/**
 * Procedure Categories and Procedures for MD in Health Administration students
 * Extracted with strict evidence from official NMC PDF
 */
export const HEALTH_ADMIN_PROCEDURES = {
  "Public Health Laboratory & Environmental Testing": [
    "Gram Staining & Acid-Fast Bacilli (AFB) Staining",
    "Thick and Thin Peripheral Blood Smear Examination (Malarial Parasites)",
    "Collection, Preservation, and Dispatch of Biological Samples",
    "Collection & Physical/Chemical/Microbiological Analysis of Water Samples",
    "Testing of Water Purifiers & Chlorine Demand",
    "Mosquito, Flea, and Tick Collection, Mounting, and Identification",
    "Collection & Dispatch of Food Samples for Nutritional Analysis",
  ],
};

export const HEALTH_ADMIN_CATEGORIES = Object.keys(HEALTH_ADMIN_PROCEDURES);

export const isMDInHealthAdminDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("health administration") ||
    (d.includes("health") && d.includes("admin"))
  );
};
